var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaintaince(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 76,
    viewBox: "0 0 78 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_868_1528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5117 30.5096C56.9286 25.2857 62.2363 24.9229 62.2363 24.9229L57.0279 19.016L51.8195 13.1108C51.8195 13.1108 50.808 18.3454 44.8472 24.0851L26.679 40.1784C26.679 40.1784 20.8247 45.2404 15.3501 45.4147L20.5585 51.3198L25.7669 57.2267C26.6116 51.8036 32.3435 46.6011 32.3435 46.6011L50.5117 30.5078V30.5096Z",
    fill: "url(#paint0_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5027 19.1388C66.2755 20.0904 67.4521 18.2441 67.4521 18.2441L75.223 9.49137C77.0206 8.04889 77.207 10.4341 77.207 10.4341C74.6214 22.2852 69.3101 24.6668 69.3101 24.6668C61.7095 28.5461 55.1684 20.6631 55.1684 20.6631C48.1358 12.1202 52.9413 6.10482 52.9413 6.10482C52.9413 6.10482 55.9528 1.1157 68.004 0.000488281C68.004 0.000488281 70.3429 0.477167 68.6925 2.08862L59.0707 8.74256C59.0707 8.74256 57.1223 9.74928 57.8232 11.5671C57.8232 11.5671 59.4771 16.8443 64.4992 19.1388H64.5027Z",
    fill: "url(#paint1_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8145 1.37891L58.3303 8.63047C58.3303 8.63047 56.2061 9.72968 56.9691 11.7093C56.9691 11.7093 58.7721 17.4615 64.2449 19.9605C66.1775 20.9974 67.4605 18.984 67.4605 18.984L75.9288 9.44687C76.1684 9.253 76.3813 9.12494 76.573 9.0449C76.2784 8.90794 75.8614 8.96486 75.2651 9.44332L67.4942 18.1961C67.4942 18.1961 66.3177 20.0423 64.5448 19.0907C59.5228 16.7963 57.8689 11.519 57.8689 11.519C57.1697 9.703 59.1164 8.6945 59.1164 8.6945L68.7382 2.04057C69.2865 1.5052 69.393 1.09611 69.2936 0.786621C69.1907 0.968044 69.0363 1.1637 68.8163 1.37891H68.8145Z",
    fill: "#BABCBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2066 10.4357C77.2066 10.4357 77.0984 9.04653 76.2448 9.03053C76.4914 9.39693 76.5323 9.93408 76.5323 9.93408C74.2519 20.3854 69.5688 22.486 69.5688 22.486C62.8662 25.9064 57.097 18.9536 57.097 18.9536C50.8931 11.4193 55.1326 6.11354 55.1326 6.11354C55.1326 6.11354 57.7873 1.71316 68.4171 0.729561C68.4171 0.729561 68.9441 0.83628 69.276 1.1262C69.3665 0.276005 68.0036 -0.00146484 68.0036 -0.00146484C55.9524 1.11375 52.941 6.10287 52.941 6.10287C52.941 6.10287 48.1336 12.1183 55.1663 20.6629C55.1663 20.6629 61.7074 28.5441 69.3079 24.6667C69.3079 24.6667 74.6175 22.285 77.2048 10.4339L77.2066 10.4357Z",
    fill: "#8C8E90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.706 51.5368C10.9314 50.5852 9.75488 52.4315 9.75488 52.4315L1.98398 61.1842C0.184557 62.6267 0 60.2415 0 60.2415C2.58557 48.3904 7.89512 46.0087 7.89512 46.0087C15.4957 42.1313 22.0368 50.0125 22.0368 50.0125C29.0694 58.5554 24.2639 64.5708 24.2639 64.5708C24.2639 64.5708 21.2524 69.5599 9.20121 70.6751C9.20121 70.6751 6.86231 70.1984 8.5109 68.5869L18.1327 61.933C18.1327 61.933 20.0812 60.9263 19.382 59.1085C19.382 59.1085 17.7281 53.8313 12.706 51.5368Z",
    fill: "url(#paint2_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39244 69.2986L18.8785 62.0471C18.8785 62.0471 21.0009 60.9496 20.2396 58.97C20.2396 58.97 18.4366 53.2178 12.9638 50.7188C11.0312 49.6819 9.75 51.6935 9.75 51.6935L1.27814 61.2307C1.03857 61.4228 0.825623 61.5526 0.635742 61.6327C0.928548 61.7696 1.34735 61.7145 1.94361 61.236L9.71451 52.4833C9.71451 52.4833 10.8911 50.637 12.6639 51.5886C17.6859 53.8831 19.3398 59.1603 19.3398 59.1603C20.0408 60.9763 18.0923 61.9848 18.0923 61.9848L8.47052 68.6388C7.92218 69.1741 7.8157 69.5832 7.91508 69.8909C8.018 69.7113 8.17239 69.5156 8.39244 69.3004V69.2986Z",
    fill: "#BABCBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000131196 60.2415C0.000131196 60.2415 0.108381 61.6307 0.96018 61.6449C0.713513 61.2785 0.672698 60.7413 0.672698 60.7413C2.95304 50.29 7.63616 48.1876 7.63616 48.1876C14.3388 44.7673 20.1079 51.72 20.1079 51.72C26.3101 59.2544 22.0724 64.5583 22.0724 64.5583C22.0724 64.5583 19.4158 68.9587 8.78609 69.9423C8.78609 69.9423 8.25904 69.8356 7.92719 69.5457C7.83669 70.3958 9.19957 70.6751 9.19957 70.6751C21.2508 69.5581 24.2622 64.569 24.2622 64.569C24.2622 64.569 29.0696 58.5536 22.0351 50.0107C22.0351 50.0107 15.494 42.1277 7.89347 46.007C7.89347 46.007 2.58392 48.3904 -0.00341797 60.2415H0.000131196Z",
    fill: "#8C8E90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5857 48.472C26.5422 49.3969 24.9486 49.2991 24.0258 48.2515C23.1031 47.2056 23.2007 45.6084 24.2459 44.6817L49.1948 22.582C50.2382 21.6571 51.8318 21.7549 52.7563 22.8025C53.6791 23.8484 53.5797 25.4456 52.5363 26.3705L27.5874 48.4703L27.5857 48.472Z",
    fill: "#9B9DA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6994 47.6825C26.6932 48.5736 25.2824 48.6199 24.5495 47.7875C23.8148 46.955 24.0349 45.557 25.0393 44.6659L49.0778 23.3719C50.0822 22.4808 51.493 22.4346 52.2276 23.267C52.9623 24.0994 52.7423 25.4974 51.7379 26.3885L27.6994 47.6825Z",
    fill: "url(#paint3_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.976 50.3736C47.3247 53.5734 49.9102 55.7469 49.9102 55.7469L67.672 74.3997C68.8096 75.5931 70.6959 75.6376 71.8867 74.4975L77.0756 69.5333C78.2663 68.3932 78.3107 66.5024 77.1732 65.309L59.4114 46.6563C59.4114 46.6563 57.3653 43.9669 54.1462 44.4703C54.1462 44.4703 51.4861 45.5108 50.6946 40.4043L47.3886 43.5667L44.0825 46.7292C49.1348 47.759 47.9742 50.3736 47.9742 50.3736H47.976Z",
    fill: "url(#paint4_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1482 44.4703C54.1482 44.4703 51.4881 45.5108 50.6966 40.4043L49.3604 41.6831C49.4491 42.3661 49.5662 43.042 49.7082 43.7001C50.6132 47.9138 54.9414 50.0748 58.0682 52.556C61.6902 55.4303 65.0193 59.0303 67.8391 62.6961C70.2507 65.8283 72.4406 69.1704 73.4485 73.0034L77.0758 69.5351C78.2665 68.3949 78.3109 66.5042 77.1734 65.3108L59.4116 46.658C59.4116 46.658 57.3655 43.9687 54.1464 44.4721L54.1482 44.4703Z",
    fill: "#1C75BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7331 10.0246L15.3452 12.3086L44.3294 42.7509L46.7173 40.4669L17.7331 10.0246Z",
    fill: "url(#paint5_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6435 44.9879L49.073 37.8818C49.4017 37.5674 49.9235 37.5796 50.2372 37.9091L51.167 38.8857C51.4807 39.2151 51.4685 39.7382 51.1398 40.0525L43.7103 47.1586C43.3817 47.473 42.8598 47.4607 42.5462 47.1313L41.6163 46.1547C41.3027 45.8253 41.3149 45.3022 41.6435 44.9879Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3425 38.2519C49.2591 38.1648 49.2644 38.0279 49.3496 37.9461C49.4348 37.8643 49.5714 37.866 49.6548 37.9532L51.0922 39.4627C51.1738 39.5481 51.1703 39.685 51.0851 39.7668C50.9982 39.8486 50.8615 39.8468 50.7799 39.7614L49.3425 38.2519Z",
    fill: "#3B3B3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8918 38.6825C48.8084 38.5954 48.8137 38.4585 48.8989 38.3767C48.9841 38.2949 49.1225 38.2967 49.2041 38.3838L50.6415 39.8934C50.7232 39.9787 50.7196 40.1157 50.6344 40.1992C50.5492 40.281 50.4126 40.2792 50.331 40.1921L48.8936 38.6825H48.8918Z",
    fill: "#3B3B3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4427 39.1127C48.3593 39.0256 48.3629 38.8887 48.4498 38.8069C48.535 38.7251 48.6734 38.7269 48.755 38.814L50.1925 40.3236C50.2741 40.4089 50.2705 40.5458 50.1854 40.6294C50.1002 40.7112 49.9635 40.7076 49.8819 40.6223L48.4445 39.1127H48.4427Z",
    fill: "#3B3B3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.992 39.5434C47.9086 39.4563 47.9122 39.3211 47.9991 39.2376C48.0861 39.1558 48.2227 39.1576 48.3044 39.2447L49.7418 40.7542C49.8234 40.8396 49.8199 40.9765 49.7347 41.0601C49.6495 41.1419 49.5129 41.1383 49.4312 41.0529L47.9938 39.5434H47.992Z",
    fill: "#3B3B3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5414 39.9736C47.4579 39.8864 47.4615 39.7495 47.5485 39.6677C47.6336 39.586 47.7721 39.5877 47.8537 39.6749L49.2911 41.1844C49.3727 41.2698 49.3692 41.4067 49.284 41.4902C49.197 41.572 49.0604 41.5702 48.9788 41.4831L47.5414 39.9736Z",
    fill: "#3B3B3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0921 40.4042C47.0087 40.3171 47.0123 40.1802 47.0992 40.0984C47.1862 40.0166 47.3228 40.0184 47.4045 40.1055L48.8419 41.6151C48.9235 41.7004 48.92 41.8373 48.8348 41.9209C48.7496 42.0027 48.613 41.9991 48.5313 41.9138L47.0939 40.4042H47.0921Z",
    fill: "#3B3B3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6415 40.8346C46.558 40.7475 46.5616 40.6106 46.6486 40.5288C46.7355 40.4452 46.8721 40.4488 46.9538 40.5359L48.3912 42.0454C48.4728 42.1308 48.4693 42.2677 48.3841 42.3513C48.2971 42.4331 48.1605 42.4313 48.0789 42.3442L46.6415 40.8346Z",
    fill: "#3B3B3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1927 41.2649C46.1093 41.1778 46.1129 41.0409 46.1998 40.9591C46.285 40.8773 46.4216 40.8809 46.505 40.9662L47.9425 42.4758C48.0241 42.5611 48.0205 42.698 47.9354 42.7798C47.8484 42.8616 47.7118 42.8598 47.6301 42.7727L46.1927 41.2631V41.2649Z",
    fill: "#3B3B3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.742 41.6952C45.6586 41.6081 45.6622 41.4712 45.7491 41.3894C45.8361 41.3076 45.9727 41.3094 46.0544 41.3965L47.4918 42.9061C47.5734 42.9914 47.5699 43.1283 47.4847 43.2119C47.3995 43.2937 47.2629 43.2901 47.1812 43.2048L45.7438 41.6952H45.742Z",
    fill: "#3B3B3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2909 42.1257C45.2075 42.0386 45.211 41.9017 45.298 41.8199C45.3831 41.7381 45.5198 41.7417 45.6032 41.827L47.0406 43.3366C47.1222 43.4219 47.1187 43.5589 47.0335 43.6406C46.9466 43.7242 46.8099 43.7207 46.7283 43.6335L45.2909 42.124V42.1257Z",
    fill: "#3B3B3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8421 42.5561C44.7587 42.469 44.7623 42.332 44.8492 42.2503C44.9362 42.1685 45.0728 42.1702 45.1545 42.2574L46.5919 43.7669C46.6735 43.8523 46.67 43.9892 46.5848 44.0728C46.4996 44.1545 46.363 44.151 46.2813 44.0656L44.8439 42.5561H44.8421Z",
    fill: "#3B3B3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3915 42.9885C44.308 42.9014 44.3116 42.7645 44.3986 42.6827C44.4837 42.6009 44.6204 42.6045 44.7038 42.6898L46.1412 44.1994C46.2228 44.2847 46.2193 44.4216 46.1341 44.5034C46.0471 44.5852 45.9105 44.5834 45.8289 44.4963L44.3915 42.9868V42.9885Z",
    fill: "#3B3B3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9422 43.4187C43.8588 43.3316 43.8624 43.1947 43.9493 43.1129C44.0345 43.0311 44.1712 43.0347 44.2546 43.12L45.692 44.6296C45.7736 44.7149 45.7701 44.8518 45.6849 44.9336C45.5979 45.0172 45.4613 45.0136 45.3796 44.9283L43.9422 43.4187Z",
    fill: "#3B3B3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4919 43.8495C43.4085 43.7624 43.4138 43.6255 43.499 43.5437C43.5859 43.4619 43.7226 43.4637 43.8042 43.5508L45.2416 45.0604C45.3233 45.1457 45.3197 45.2826 45.2345 45.3662C45.1493 45.448 45.0109 45.4462 44.9293 45.3591L43.4919 43.8495Z",
    fill: "#3B3B3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0428 44.2796C42.9594 44.1924 42.963 44.0555 43.0499 43.9737C43.1351 43.8919 43.2717 43.8955 43.3551 43.9808L44.7926 45.4904C44.8742 45.5758 44.8706 45.7127 44.7855 45.7945C44.6985 45.878 44.5619 45.8745 44.4802 45.7873L43.0428 44.2778V44.2796Z",
    fill: "#3B3B3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.592 44.7104C42.5086 44.6233 42.5139 44.4863 42.5991 44.4046C42.6843 44.3228 42.8209 44.3245 42.9043 44.4117L44.3417 45.9212C44.4234 46.0066 44.4198 46.1435 44.3346 46.2253C44.2477 46.3071 44.111 46.3053 44.0294 46.2199L42.592 44.7104Z",
    fill: "#3B3B3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1415 45.1404C42.058 45.0533 42.0616 44.9164 42.1486 44.8346C42.2337 44.7528 42.3704 44.7563 42.4538 44.8417L43.8912 46.3512C43.9728 46.4366 43.9693 46.5735 43.8841 46.6553C43.7971 46.7371 43.6605 46.7353 43.5789 46.6482L42.1415 45.1386V45.1404Z",
    fill: "#3B3B3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6922 45.5709C41.6088 45.4838 41.6124 45.3487 41.6993 45.2651C41.7863 45.1815 41.9229 45.1851 42.0046 45.2722L43.442 46.7818C43.5236 46.8671 43.5201 47.004 43.4349 47.0876C43.3497 47.1694 43.2131 47.1658 43.1314 47.0805L41.694 45.5709H41.6922Z",
    fill: "#3B3B3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5288 7.18787C10.2608 6.90684 10.2714 6.46218 10.5518 6.1936L11.8615 4.93965C12.1419 4.67286 12.5855 4.68175 12.8535 4.96278L17.7211 9.05723C17.9891 9.33826 17.9785 9.78292 17.6981 10.0497L15.3734 12.273C15.093 12.5398 14.6493 12.5309 14.3832 12.2499L10.5288 7.18431V7.18787Z",
    fill: "url(#paint6_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9218 9.23318C16.1898 9.51421 16.1791 9.95887 15.8987 10.2274L14.1295 11.9207L14.3832 12.2533C14.6512 12.5344 15.0948 12.5433 15.3734 12.2765L17.6981 10.0531C17.9785 9.78456 17.9892 9.3399 17.7212 9.06065L12.8535 4.96619C12.5856 4.68517 12.1419 4.67627 11.8615 4.94307L11.3735 5.41086L15.9218 9.23674V9.23318Z",
    fill: "url(#paint7_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1375 10.5567C14.8446 10.8715 14.5483 11.1827 14.2466 11.4887L14.2022 11.5349L14.1597 11.4833C13.8669 11.1152 13.5705 10.7505 13.283 10.377C12.992 10.0071 12.7098 9.62998 12.4241 9.25647C12.142 8.87939 11.8598 8.50232 11.583 8.12169C11.3044 7.74106 11.0364 7.35509 10.7613 6.97268L10.7578 6.96912C10.7329 6.91754 10.7205 6.87307 10.7116 6.82327C10.6992 6.77525 10.7063 6.72545 10.7045 6.67742C10.7045 6.65252 10.7134 6.6294 10.7152 6.60628L10.7294 6.53513C10.74 6.48888 10.7649 6.44798 10.7826 6.40529C10.7986 6.36082 10.8252 6.32169 10.8536 6.28434L10.9352 6.17228C11.0009 6.10825 11.0701 6.04778 11.1375 5.9873L10.9619 6.19363L10.8927 6.30746C10.8678 6.34481 10.8483 6.38394 10.8359 6.42663C10.8234 6.46754 10.8021 6.50845 10.7986 6.55114L10.7915 6.61517C10.7915 6.63651 10.7826 6.65608 10.788 6.67742C10.795 6.71833 10.7915 6.7628 10.8057 6.80193C10.8146 6.84106 10.8323 6.88197 10.8483 6.91042L10.8447 6.90687C11.1375 7.27505 11.4357 7.64145 11.7249 8.01141C12.0142 8.38137 12.2999 8.75667 12.5856 9.13018C12.8678 9.50726 13.1517 9.88255 13.4285 10.2632C13.7089 10.642 13.9786 11.028 14.2537 11.4104L14.1668 11.4033C14.4862 11.1152 14.8092 10.8324 15.1375 10.5549V10.5567Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2359 49.1018C54.8739 48.7212 54.8579 48.1449 55.2004 47.8176L55.7275 47.3142C56.0717 46.9852 56.6431 47.0279 57.0069 47.4085L75.6099 66.9434C75.9719 67.3241 75.9879 67.8986 75.6436 68.2276L75.1166 68.731C74.7741 69.06 74.2009 69.0173 73.8388 68.6367L55.2359 49.1018Z",
    fill: "url(#paint8_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0037 51.2378C52.6417 50.8572 52.6257 50.2809 52.97 49.9519L53.4953 49.4485C53.8396 49.1195 54.4127 49.1622 54.7748 49.5428L73.3777 69.0777C73.7397 69.4583 73.7557 70.0329 73.4114 70.3619L72.8861 70.8653C72.5419 71.1943 71.9687 71.1516 71.6067 70.771L53.0037 51.2361V51.2378Z",
    fill: "url(#paint9_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7711 53.3723C50.409 52.9917 50.3931 52.4154 50.7356 52.0881L51.2626 51.5848C51.6069 51.2557 52.1783 51.2984 52.5421 51.679L71.145 71.214C71.5071 71.5946 71.523 72.1691 71.1788 72.4981L70.6517 73.0015C70.3074 73.3305 69.736 73.2879 69.374 72.9072L50.7711 53.3723Z",
    fill: "url(#paint10_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2011 55.9335L21.705 60.0546L18.0103 57.8562L13.4443 53.7173L17.2011 55.9335Z",
    fill: "url(#paint11_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.292 41.1919L30.4445 45.7435L32.4693 49.5711L28.331 45.0871L26.292 41.1919Z",
    fill: "url(#paint12_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6241 63.5303L23.167 67.4771L18.2603 69.005L13.5825 65.1417L18.6241 63.5303Z",
    fill: "url(#paint13_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5769 41.7686L41.4597 46.4215L39.7508 51.3395L35.7793 46.8253L37.5769 41.7686Z",
    fill: "url(#paint14_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7881 51.6593C32.5476 52.465 33.3071 53.269 34.0666 54.0747C34.2157 54.233 34.9948 54.8271 34.7676 55.0867C34.6203 55.2557 34.3133 55.0281 34.1518 54.9747C33.7348 54.8395 33.2681 54.8075 32.8333 54.8182C31.9584 54.8395 31.0889 55.085 30.3152 55.4958C29.1369 56.1201 28.1307 57.1358 27.5149 58.3203C27.0233 59.2648 26.7589 60.3622 26.8725 61.4276C26.908 61.7602 26.9701 62.7172 26.317 62.2903C25.357 61.6606 24.5354 60.6308 23.6942 59.8482C22.9826 59.1848 22.5762 58.2527 22.4822 57.2923C22.3757 56.1931 22.6596 55.069 23.1707 54.1014C23.8184 52.8723 24.8459 51.8354 26.0668 51.1791C27.1813 50.5796 28.5087 50.2826 29.7597 50.5476C30.3737 50.6775 30.9665 50.946 31.4527 51.3462C31.5716 51.4441 31.6834 51.549 31.7881 51.6593Z",
    fill: "url(#paint15_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1383 53.7743C46.9892 53.0487 46.7479 52.3443 46.4107 51.6844C46.2315 51.334 46.0132 50.9534 45.7399 50.5016L41.9334 45.9038C42.2085 46.3645 42.4303 46.7522 42.6113 47.1097C42.9556 47.7874 43.1952 48.4989 43.3424 49.2441C43.4241 49.6568 43.4951 50.1263 43.5696 50.6991L38.6629 53.8971C38.6575 54.0127 38.6504 54.1265 38.6416 54.2421C38.6238 54.4751 38.5972 54.7099 38.5653 54.9411C38.5493 55.0585 38.5298 55.1759 38.5103 55.2951L42.4818 59.6243C42.5013 59.5087 42.5173 59.3949 42.5332 59.281C42.5634 59.0552 42.5865 58.8275 42.6024 58.5998C42.6095 58.4878 42.6166 58.3757 42.6202 58.2637L47.3725 55.1919C47.2944 54.6334 47.2217 54.1745 47.1383 53.7708V53.7743Z",
    fill: "url(#paint16_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8583 66.6322C26.7429 66.6482 26.6258 66.6624 26.5105 66.6731C26.2798 66.698 26.0491 66.714 25.8184 66.7229C25.703 66.7282 25.5877 66.73 25.4741 66.73L22.1361 71.5483C22.0137 71.527 21.8717 71.5074 21.7706 71.4896C21.3944 71.4185 21.0199 71.3367 20.6544 71.2211C20.0954 71.0432 19.547 70.8191 19.0093 70.5843C18.4663 70.3478 17.9676 70.0365 17.4761 69.7074L22.106 73.4853C22.436 73.7076 22.7679 73.9282 23.1175 74.1149C23.6978 74.4226 24.3206 74.6645 24.9364 74.8869C25.2771 75.0096 25.6445 75.1145 26.0065 75.1928C26.2248 75.239 26.443 75.2817 26.6613 75.3209L29.8751 70.6501C29.9869 70.6501 30.0987 70.6501 30.2105 70.6448C30.4359 70.6377 30.6612 70.6234 30.8848 70.6021C30.9984 70.5914 31.1102 70.579 31.2238 70.5648L26.8547 66.6304L26.8583 66.6322Z",
    fill: "url(#paint17_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8669 57.6748C42.716 58.1426 42.5634 58.6104 42.3771 59.0639C41.9867 60.012 41.5093 60.9564 40.9805 61.8351C40.7249 62.2602 40.4197 62.6977 40.1251 63.1121L34.97 62.2388C34.7925 62.4309 34.608 62.6177 34.4216 62.8009C34.2353 62.9823 34.0436 63.1584 33.8484 63.3291L34.5033 68.5744C33.9496 68.9426 33.4651 69.2556 33.0446 69.5064C32.2708 69.9688 31.4599 70.3495 30.6063 70.643C30.1538 70.7977 29.6462 70.9507 29.0322 71.1267L33.3871 74.9597C33.9833 74.7943 34.4766 74.6503 34.9167 74.5026C35.7437 74.2252 36.5298 73.8605 37.2805 73.4176C37.694 73.174 38.1483 72.8823 38.6931 72.523L38.0116 67.4111C38.001 67.3222 38.4961 66.9683 38.5653 66.9007C38.7463 66.7246 38.9237 66.5432 39.0959 66.3582L44.1215 67.2528C44.4054 66.8473 44.6894 66.4418 44.9431 66.0167C45.4507 65.1665 45.9085 64.2505 46.2812 63.3309C46.4604 62.8898 46.6041 62.4363 46.7479 61.9827L42.874 57.6748H42.8669Z",
    fill: "url(#paint18_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8668 57.6749C42.7159 58.1427 42.5633 58.6104 42.377 59.064C41.9866 60.012 41.5092 60.9565 40.9804 61.8351C40.716 62.2745 40.4196 62.6942 40.125 63.1122L34.9699 62.2389C34.7924 62.431 34.6079 62.6177 34.4215 62.8009C34.2352 62.9824 34.0436 63.1584 33.8484 63.3292L34.5032 68.5762C33.9406 68.9497 33.4704 69.2539 33.0445 69.5082C32.2707 69.9707 31.458 70.3513 30.6062 70.6448C30.1537 70.7995 29.6461 70.9525 29.0321 71.1286L26.8636 66.6322C26.6329 66.6642 26.4022 66.6873 26.1697 66.7051C25.9408 66.7211 25.7101 66.7318 25.4794 66.7318L22.1361 71.5572C21.9125 71.5181 21.6889 71.4772 21.4653 71.431C20.452 71.2193 19.4281 70.8298 18.5124 70.3478C18.1539 70.1592 17.8168 69.9351 17.4814 69.711L19.4281 64.4426C19.2826 64.3021 19.1424 64.1545 19.0093 64.0015C18.8762 63.8503 18.7484 63.692 18.6278 63.5302L13.5862 65.1416C13.3626 64.6614 13.1833 64.2612 13.0396 63.893C12.7699 63.1994 12.5995 62.4826 12.5143 61.7426C12.4682 61.3353 12.4345 60.8729 12.4043 60.3126L17.0022 57.2764C17.0129 57.1662 17.0235 57.0541 17.0377 56.9421C17.0644 56.718 17.0981 56.4921 17.1389 56.2697C17.1584 56.1577 17.1815 56.0438 17.2045 55.9318L13.4478 53.7156C13.6057 53.2852 13.7654 52.8547 13.9535 52.4367C14.3439 51.5688 14.8071 50.7097 15.3146 49.9039C15.5666 49.5037 15.8434 49.1213 16.122 48.7389L20.688 49.3881C20.8566 49.2085 21.0288 49.0306 21.2045 48.8599C21.3801 48.6891 21.5594 48.5219 21.7439 48.3601L21.2825 43.7089C21.7954 43.3549 22.2248 43.0686 22.6135 42.8249C23.3215 42.382 24.0651 42.0049 24.8459 41.7026C25.2611 41.5425 25.7314 41.3789 26.2993 41.1903L28.3383 45.0873C28.5601 45.0482 28.7819 45.0162 29.0055 44.9895C29.2273 44.9646 29.4509 44.9451 29.6728 44.9326L32.8564 40.3828C33.0764 40.4042 33.2982 40.4255 33.5165 40.4522C33.875 40.4966 34.2512 40.5642 34.6096 40.6567C35.2378 40.8168 35.8944 40.9982 36.5031 41.2455C36.874 41.3949 37.2289 41.5816 37.5821 41.7684L35.7844 46.8251C35.9406 46.9549 36.0896 47.0919 36.2352 47.2342C36.3789 47.3747 36.5191 47.5223 36.6504 47.6753L41.9387 45.9055C42.2137 46.3662 42.4356 46.7539 42.6166 47.1115C42.9591 47.7856 43.2004 48.5041 43.3477 49.2458C43.4293 49.6585 43.5003 50.128 43.5748 50.7008L38.6681 53.8988C38.6628 54.0144 38.6557 54.1282 38.6468 54.2438C38.6291 54.4768 38.6025 54.7116 38.5705 54.9429C38.5545 55.0602 38.535 55.1776 38.5155 55.2968L42.8721 57.6749H42.8668ZM32.1731 57.1875C33.135 55.3235 33.1669 52.6893 31.3835 51.2842C30.1874 50.3415 28.4785 50.2846 27.0375 50.7719C25.0553 51.4407 23.428 53.0842 22.7732 55.0745C22.3118 56.4814 22.3579 58.132 23.2363 59.3219C24.2532 60.7003 26.2052 61.1628 27.8591 60.727C29.6674 60.2504 31.3231 58.8363 32.1749 57.1857L32.1731 57.1875Z",
    fill: "url(#paint19_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4467 46.3626C35.9461 47.4351 37.8769 51.076 37.5078 54.6316C37.2203 57.4009 35.8095 59.9995 33.8539 61.9472C32.0172 63.7774 29.618 65.1185 27.0413 65.5045C24.477 65.8886 21.5774 65.1523 19.8205 63.1282C18.3033 61.3815 17.778 58.8238 18.0939 56.5738C18.4647 53.9414 19.8294 51.4905 21.698 49.6282C23.3981 47.9332 25.7671 46.5707 28.1593 46.126C29.547 45.8681 31.0589 45.934 32.4449 46.3591L32.4467 46.3626ZM34.4165 57.9523C35.5025 55.841 35.8947 53.1713 34.7039 51.0191C33.8805 49.5286 32.397 48.4223 30.7378 48.0577C29.2631 47.734 27.7032 47.9812 26.3031 48.545C23.895 49.5126 21.8808 51.43 20.7912 53.7903C19.6537 56.2555 19.6289 59.4197 21.4088 61.4669C23.0307 63.3309 25.8399 63.8592 28.209 63.1709C30.8087 62.4167 33.1831 60.3517 34.4165 57.9541V57.9523Z",
    fill: "url(#paint20_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7487 63.6333L52.62 66.2621L50.2651 64.8605L47.353 62.2192L49.7487 63.6333Z",
    fill: "url(#paint21_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5459 54.2314L58.1936 57.136L59.4855 59.5763L56.8467 56.7162L55.5459 54.2314Z",
    fill: "url(#paint22_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6552 68.4785L53.5531 70.9953L50.4245 71.97L47.4414 69.5066L50.6552 68.4785Z",
    fill: "url(#paint23_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7436 54.5996L65.2191 57.5682L64.1295 60.7039L61.5972 57.8243L62.7436 54.5996Z",
    fill: "url(#paint24_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0526 60.9066C59.537 61.4206 60.0215 61.9329 60.506 62.4469C60.6018 62.5483 61.0987 62.9271 60.9532 63.0926C60.8591 63.1993 60.6639 63.0552 60.561 63.0214C60.2948 62.936 59.9967 62.9147 59.7198 62.9218C59.1608 62.936 58.6072 63.0926 58.1138 63.354C57.3614 63.7524 56.7208 64.3999 56.3286 65.1558C56.0163 65.7588 55.8459 66.4578 55.9187 67.1372C55.9417 67.3489 55.9808 67.9607 55.5638 67.6868C54.9515 67.2848 54.4262 66.6285 53.8903 66.1305C53.436 65.7072 53.1769 65.1131 53.1166 64.5013C53.0474 63.8005 53.2302 63.0837 53.5549 62.4665C53.9684 61.6821 54.6232 61.0222 55.4023 60.6024C56.1121 60.22 56.9586 60.0297 57.7571 60.1987C58.1493 60.2823 58.5273 60.453 58.8361 60.7074C58.9124 60.7696 58.9834 60.8372 59.0508 60.9084L59.0526 60.9066Z",
    fill: "url(#paint25_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8414 62.2568C68.7473 61.7944 68.5929 61.3444 68.3764 60.9246C68.2611 60.7005 68.1226 60.4586 67.9487 60.1705L65.5211 57.2393C65.6968 57.5327 65.8388 57.78 65.9541 58.0076C66.1742 58.4398 66.3268 58.8934 66.4208 59.3701C66.4723 59.6333 66.5184 59.9339 66.5663 60.2985L63.436 62.3387C63.4324 62.4116 63.4289 62.4863 63.4218 62.5592C63.4111 62.7086 63.3934 62.858 63.3739 63.0056C63.3632 63.0804 63.3508 63.1551 63.3384 63.2315L65.8707 65.9938C65.8831 65.9209 65.8938 65.8479 65.9026 65.775C65.9222 65.6309 65.9364 65.4851 65.947 65.341C65.9523 65.2699 65.9559 65.1969 65.9577 65.1258L68.9886 63.1675C68.939 62.8118 68.8928 62.5183 68.8396 62.2622L68.8414 62.2568Z",
    fill: "url(#paint26_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9082 70.4565C55.8337 70.4672 55.7609 70.4761 55.6864 70.4832C55.5391 70.4992 55.3918 70.5099 55.2445 70.5152C55.1718 70.5188 55.0972 70.5206 55.0245 70.5206L52.895 73.5941C52.8169 73.5816 52.7264 73.5692 52.6625 73.5567C52.4229 73.5123 52.1834 73.4589 51.9509 73.386C51.5942 73.2721 51.2446 73.1299 50.9021 72.9805C50.5561 72.8293 50.2366 72.6318 49.9243 72.422L52.8772 74.832C53.0866 74.9743 53.2996 75.1148 53.5232 75.234C53.8923 75.4297 54.2898 75.5844 54.6837 75.7267C54.9002 75.8049 55.1363 75.8725 55.367 75.9223C55.5054 75.9526 55.6456 75.9793 55.784 76.0042L57.8336 73.0249C57.9046 73.0249 57.9756 73.0249 58.0484 73.0214C58.1921 73.016 58.3358 73.0071 58.4778 72.9947C58.5488 72.9876 58.6215 72.9805 58.6943 72.9698L55.9082 70.4601V70.4565Z",
    fill: "url(#paint27_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1173 64.7449C66.0215 65.0438 65.9239 65.3408 65.805 65.6307C65.5565 66.2355 65.2513 66.8384 64.9141 67.3987C64.7509 67.669 64.5557 67.9483 64.3676 68.2133L61.0793 67.6566C60.9657 67.7793 60.8486 67.8985 60.7297 68.0141C60.6108 68.1297 60.4883 68.2418 60.3641 68.352L60.7811 71.6977C60.428 71.9325 60.1192 72.1317 59.8495 72.2918C59.3561 72.587 58.838 72.8289 58.2949 73.0157C58.0057 73.1153 57.6827 73.2131 57.2905 73.3234L60.0677 75.7672C60.4475 75.6623 60.7634 75.5698 61.042 75.4755C61.569 75.2995 62.0713 75.0665 62.5504 74.7837C62.813 74.6271 63.1041 74.4421 63.4519 74.2127L63.0171 70.9524C63.01 70.8955 63.3259 70.6696 63.3702 70.6269C63.4856 70.5149 63.5992 70.3993 63.7074 70.2819L66.9123 70.8528C67.0933 70.5949 67.2743 70.3352 67.4376 70.0649C67.7606 69.5224 68.0534 68.9372 68.2912 68.352C68.4047 68.071 68.497 67.7811 68.5875 67.4912L66.1173 64.7432V64.7449Z",
    fill: "url(#paint28_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1172 64.7451C66.0214 65.0439 65.9238 65.3409 65.8049 65.6308C65.5565 66.2356 65.2512 66.8385 64.9141 67.3988C64.7455 67.6798 64.5574 67.9466 64.3675 68.2134L61.0792 67.6567C60.9656 67.7794 60.8485 67.8986 60.7296 68.0142C60.6107 68.1298 60.4883 68.2419 60.364 68.3522L60.7811 71.6978C60.4226 71.9362 60.1227 72.13 59.8494 72.2919C59.3561 72.5871 58.8379 72.8308 58.2949 73.0158C58.0056 73.1154 57.6826 73.2132 57.2905 73.3235L55.9063 70.4563C55.759 70.4759 55.6117 70.4919 55.4644 70.5026C55.3171 70.5132 55.1716 70.5186 55.0243 70.5203L52.893 73.5974C52.7511 73.5725 52.6073 73.5458 52.4654 73.5174C51.8194 73.3822 51.1664 73.1332 50.5825 72.8273C50.3536 72.7063 50.1389 72.564 49.9242 72.4199L51.1664 69.0601C51.0741 68.9694 50.9836 68.8769 50.8984 68.779C50.8132 68.683 50.7316 68.5816 50.6553 68.4785L47.4397 69.5065C47.296 69.2006 47.1824 68.9445 47.0919 68.7097C46.9198 68.2668 46.8115 67.8097 46.7565 67.3383C46.7264 67.0787 46.7051 66.7834 46.6855 66.4259L49.6189 64.4889C49.626 64.4178 49.6331 64.3466 49.642 64.2755C49.6597 64.1314 49.681 63.9891 49.7059 63.8468C49.7183 63.7757 49.7325 63.7028 49.7485 63.6316L47.3528 62.2176C47.4539 61.9437 47.5551 61.668 47.6758 61.4012C47.9242 60.848 48.2206 60.3002 48.5435 59.7862C48.7032 59.5318 48.8807 59.2864 49.0582 59.0445L51.9703 59.4589C52.0767 59.3433 52.1868 59.2312 52.3003 59.121C52.4121 59.0125 52.5275 58.9058 52.6446 58.8026L52.35 55.8358C52.6765 55.6099 52.9498 55.4267 53.1983 55.272C53.6508 54.9892 54.1246 54.749 54.6215 54.557C54.8877 54.4538 55.1858 54.3506 55.5478 54.2297L56.8486 56.7145C56.9906 56.6895 57.1325 56.6682 57.2745 56.6522C57.4164 56.6362 57.5584 56.6237 57.7004 56.6166L59.7305 53.7139C59.8707 53.7281 60.0127 53.7405 60.1529 53.7583C60.3818 53.7868 60.6213 53.8295 60.8503 53.8882C61.2513 53.9913 61.6701 54.1069 62.057 54.2635C62.293 54.3595 62.5201 54.4769 62.7455 54.5961L61.5991 57.8208C61.6985 57.9044 61.7943 57.9897 61.8866 58.0805C61.9789 58.1712 62.0676 58.2637 62.151 58.3615L65.5227 57.2338C65.6984 57.5273 65.8404 57.7745 65.9557 58.0022C66.174 58.4326 66.3284 58.8915 66.4225 59.3646C66.4739 59.6279 66.5201 59.9285 66.568 60.2931L63.4376 62.3332C63.4341 62.4061 63.4305 62.4808 63.4234 62.5538C63.4128 62.7032 63.395 62.8526 63.3755 63.0002C63.3649 63.0749 63.3524 63.1496 63.34 63.2261L66.1172 64.7433V64.7451ZM59.2975 64.4338C59.9115 63.2439 59.931 61.5648 58.7935 60.6684C58.0305 60.0672 56.9409 60.0316 56.0216 60.3411C54.7581 60.768 53.72 61.8156 53.303 63.0856C53.0084 63.982 53.0386 65.035 53.5975 65.7945C54.2453 66.6731 55.491 66.9684 56.5451 66.6909C57.6986 66.3868 58.7545 65.485 59.2975 64.432V64.4338Z",
    fill: "url(#paint29_linear_868_1528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4713 57.5291C61.702 58.2121 62.9353 60.5351 62.6993 62.8028C62.5165 64.569 61.615 66.2268 60.3693 67.4683C59.198 68.635 57.6684 69.4906 56.0251 69.736C54.3889 69.9815 52.5416 69.5119 51.42 68.2206C50.4511 67.1054 50.1175 65.4744 50.3198 64.0408C50.5558 62.3617 51.4271 60.8001 52.6197 59.6119C53.7039 58.5305 55.2141 57.6625 56.7402 57.3797C57.6258 57.2161 58.5894 57.257 59.4731 57.5291H59.4713ZM60.7277 64.9212C61.4198 63.5748 61.67 61.8726 60.9123 60.4995C60.387 59.5497 59.4412 58.8436 58.3817 58.6106C57.4412 58.4042 56.4474 58.5625 55.553 58.9218C54.018 59.539 52.7332 60.761 52.0376 62.2657C51.3118 63.838 51.2958 65.855 52.4316 67.1605C53.4661 68.3487 55.2567 68.6866 56.7686 68.2473C58.4261 67.7653 59.9398 66.4491 60.7277 64.9212Z",
    fill: "url(#paint30_linear_868_1528)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_868_1528",
    x1: 15.3519,
    y1: 35.1697,
    x2: 62.2346,
    y2: 35.1697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F8F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_868_1528",
    x1: 51.3389,
    y1: 12.8708,
    x2: 77.207,
    y2: 12.8708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F8F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_868_1528",
    x1: 0,
    y1: 57.8065,
    x2: 25.8681,
    y2: 57.8065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F8F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_868_1528",
    x1: 24.1147,
    y1: 35.5272,
    x2: 52.6642,
    y2: 35.5272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F8F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_868_1528",
    x1: 44.0843,
    y1: 57.8635,
    x2: 78.0001,
    y2: 57.8635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126BA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2692D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_868_1528",
    x1: 23.1899,
    y1: 34.2462,
    x2: 33.177,
    y2: 24.2819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#747576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F8F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_868_1528",
    x1: 10.3353,
    y1: 8.60901,
    x2: 17.9163,
    y2: 8.60901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F8F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_868_1528",
    x1: 11.3735,
    y1: 8.60887,
    x2: 17.9164,
    y2: 8.60887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F8F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_868_1528",
    x1: 54.9537,
    y1: 58.0217,
    x2: 75.892,
    y2: 58.0217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126BA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2692D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_868_1528",
    x1: 52.7216,
    y1: 60.1578,
    x2: 73.6599,
    y2: 60.1578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126BA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2692D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_868_1528",
    x1: 50.4889,
    y1: 62.2922,
    x2: 71.4272,
    y2: 62.2922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126BA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2692D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_868_1528",
    x1: 14.0637,
    y1: 59.2596,
    x2: 16.2815,
    y2: 57.7666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#DD5E2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C32D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#7B0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_868_1528",
    x1: 28.6948,
    y1: 45.9782,
    x2: 33.2484,
    y2: 42.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#491312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5B1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6A1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#711012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#841315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#A4171B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D11C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EB2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#DA1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B11C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#981A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#8F1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#5D1617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#451515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_868_1528",
    x1: 16.5727,
    y1: 68.386,
    x2: 19.987,
    y2: 64.4683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#491312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5B1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6A1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#95181B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B71E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C42127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_868_1528",
    x1: 37.2274,
    y1: 48.7426,
    x2: 43.1806,
    y2: 39.7143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#491312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5B1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6A1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#711012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#841315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#A4171B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D11C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EB2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#DA1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B11C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#981A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#8F1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#5D1617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#451515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_868_1528",
    x1: 22.9258,
    y1: 60.661,
    x2: 32.268,
    y2: 51.0155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#C85C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C32D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B52C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#932B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#8B2824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#6E1C1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5C1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#561313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_868_1528",
    x1: 38.2494,
    y1: 56.0901,
    x2: 46.2465,
    y2: 49.4062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#491312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#5B1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6A1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#6C1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#751112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#831315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#971518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#B2181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D21C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#EB2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C91D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#901A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#671718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#4E1516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#451515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_868_1528",
    x1: 27.6764,
    y1: 66.0772,
    x2: 21.007,
    y2: 74.1924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#491312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5B1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6A1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#711012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#841315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A4171B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#D11C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#B11C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#981A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#8F1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#5D1617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#451515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_868_1528",
    x1: 30.8973,
    y1: 73.5635,
    x2: 45.0969,
    y2: 59.1018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#441413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#4B1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#571515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#681617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7E181A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#99191E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B91C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DD1E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E21F28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CD1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#AA181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#8D1417"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#791114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#6D1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#711113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#951A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D21E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EB2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C91D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#901A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#671718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#451515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_868_1528",
    x1: 20.0829,
    y1: 72.3167,
    x2: 41.2447,
    y2: 29.2209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6A1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#711012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#841315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#A4171B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D11C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#EB2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DA1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#B11C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#981A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#8F1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#5D1617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#451515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_868_1528",
    x1: 18.6049,
    y1: 51.2521,
    x2: 108.618,
    y2: 95.6223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F8F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_868_1528",
    x1: 47.747,
    y1: 65.7552,
    x2: 49.1633,
    y2: 64.8031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#DD5E2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C32D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#7B0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_868_1528",
    x1: 57.0791,
    y1: 57.2836,
    x2: 59.9827,
    y2: 54.7734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#491312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5B1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6A1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#711012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#841315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#A4171B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D11C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EB2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#DA1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B11C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#981A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#8F1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#5D1617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#451515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_868_1528",
    x1: 49.3473,
    y1: 71.5751,
    x2: 51.5251,
    y2: 69.0775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#491312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5B1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6A1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#95181B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B71E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C42127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_868_1528",
    x1: 62.52,
    y1: 59.048,
    x2: 66.3172,
    y2: 53.2896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#491312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5B1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6A1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#711012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#841315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#A4171B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D11C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EB2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#DA1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B11C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#981A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#8F1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#5D1617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#451515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_868_1528",
    x1: 53.3988,
    y1: 66.6481,
    x2: 59.3577,
    y2: 60.4969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#C85C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C32D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B52C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#932B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#8B2824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#6E1C1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5C1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#561313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_868_1528",
    x1: 63.1733,
    y1: 63.7331,
    x2: 68.2725,
    y2: 59.4705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#491312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#5B1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6A1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#6C1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#751112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#831315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#971518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#B2181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D21C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#EB2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C91D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#901A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#671718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#4E1516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#451515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_868_1528",
    x1: 56.4282,
    y1: 70.1026,
    x2: 52.1753,
    y2: 75.2796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#491312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5B1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6A1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#711012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#841315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A4171B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#D11C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EB2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#B11C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#981A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#8F1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#5D1617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#451515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_868_1528",
    x1: 58.483,
    y1: 74.8779,
    x2: 67.5386,
    y2: 65.6532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#441413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#4B1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#571515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#681617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7E181A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#99191E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B91C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DD1E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E21F28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CD1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#AA181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#8D1417"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#791114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#6D1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#711113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8F1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#951A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D21E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EB2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C91D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#901A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#671718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#451515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_868_1528",
    x1: 51.5869,
    y1: 74.0812,
    x2: 65.0827,
    y2: 46.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6A1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#711012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#841315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#A4171B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D11C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#EB2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DA1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#B11C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#981A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#8F1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#5D1617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#451515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_868_1528",
    x1: 50.6428,
    y1: 60.6489,
    x2: 108.049,
    y2: 88.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F8F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B0AF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_868_1528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintaince);
export default __webpack_public_path__ + "static/media/maintaince.97b2ee4ad10055f1a89131c1aa23fdfe.svg";
export { ForwardRef as ReactComponent };